import { createContext } from 'react';

export const IsPreviewOpenDispatchContext = createContext(null);